export default __webpack_public_path__ + "static/media/LightBlue0001.bd0f2a39.png";